import { render } from "./LgSix.vue?vue&type=template&id=cacccba4&scoped=true"
import script from "./LgSix.vue?vue&type=script&lang=js"
export * from "./LgSix.vue?vue&type=script&lang=js"

import "./LgSix.vue?vue&type=style&index=0&id=cacccba4&scoped=true&lang=css"

import exportComponent from "E:\\NC\\services\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cacccba4"]])

export default __exports__